<template>
  <mdb-col class="d-flex align-self-stretch col-md-12 col-lg-4">
    <mdb-card class="animated slideInLeft mb-4" style="min-height: 100px; width: 100%;">
      <mdb-card-body :class="card.class + ' p-4 mb-2'">
        <h5>{{ card.text }}</h5>
      </mdb-card-body>
      <mdb-card-footer v-if="selectable || selected" class="text-center">
        <mdb-btn v-if="selectable" icon="check" size="sm" @click="cardSelected">Select</mdb-btn>
        <mdb-icon icon="check" v-if="selected"/>
      </mdb-card-footer>
    </mdb-card>
  </mdb-col>
</template>
<script>

import {mdbBtn, mdbCard, mdbCardBody, mdbCardFooter, mdbCol, mdbIcon} from 'mdbvue';

export default {
  name: "word-card",
  props: {
    card: {
      type: Object,
      default: null
    },
    selectable: {
      type: Boolean,
      default: false
    }
  },
  components: {
    mdbCol, mdbCard, mdbCardBody, mdbCardFooter, mdbBtn, mdbIcon
  },
  data() {
    return {
      selected : false
    }
  },
  methods: {
    cardSelected() {
      this.selected = true
      this.$emit("cardSelected")
    }
  }
};

</script>

